import { HttpMethodEnum, HttpResponse } from '@ipevo-rd/service-web-utils'
import { ViewerReportReq } from './dto/ViewerDTO.js'
import { v1HttpClient } from './index.js'

/**
 * Viewer
 */
export const Viewer = {
	/**
	 * 取得短網址原始網址
	 * @param data {ViewerReportReq} 參數
	 * @return {Promise<HttpResponse>}
	 */
	report: (data: ViewerReportReq): Promise<HttpResponse> =>
		v1HttpClient.request({
			url: '/viewers/report/language',
			method: HttpMethodEnum.POST,
			data,
		}),
}
